import SolenoidTheory from "../content/solenoid.mdx";

/**
 * ABSolenoid — Section 3: The solenoid geometry and the AB phase.
 */
export function ABSolenoid() {
  return (
    <div className="flex flex-col gap-8 p-6 max-w-4xl mx-auto">
      <div className="mdx-content">
        <SolenoidTheory />
      </div>
    </div>
  );
}